import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReporteriaService {
  configuracion: any;
  headers: HttpHeaders = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(
    private httpClient: HttpClient,
  ) { }

  getConfig() {
    return this.httpClient.get('./assets/config/config.json');
  }

  saveLog(Modulo: string, Recurso: string, Respuesta: string, Stack: string, Estatus: boolean, Rut = null) {
    this.configuracion = this.getConfig();
    this.configuracion.subscribe((response: any) => {
      const API_URL = `${ response['api_usabilidad'] }/usabilidad/insert`;

      const data = {
        NombreTotem: localStorage.getItem('cbNombreTotem'),
        Sucursal: localStorage.getItem('cbSucursal'),
        Proyecto: response['Proyecto'],
        Modulo,
        Recurso,
        Respuesta,
        Stack,
        Estatus,
        Rut
      };

      return this.httpClient.post(API_URL, data, { headers: this.headers }).subscribe();
    });
  }

  saveTransacciones(datos: any) {
    this.configuracion = this.getConfig();
    this.configuracion.subscribe((response: any) => {
      const API_URL = `${ response['api_usabilidad'] }/usabilidad/transaccion`;

      const data = {
        NombreTotem: localStorage.getItem('cbNombreTotem'),
        Sucursal: localStorage.getItem('cbSucursal'),
        Proyecto: response['Proyecto'],
        ...datos
      };

      return this.httpClient.post(API_URL, data, { headers: this.headers }).subscribe();
    });
  }
}
